import moment from "moment";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const offsetToMinutes = (offset) => {
  const [hours, minutes, seconds] = offset.split(":").map(Number);
  return hours * 60 + minutes + Math.sign(hours) * (seconds > 0 ? 1 : 0);
};

const formatPrice = (value, decimalPlaces) => {
  if (value === null || value === undefined) return "";
  return Number(value).toFixed(decimalPlaces);
};


const defaultRender = (value) => (value ? value : "0.00");
const useHistoryCell = () => {
  const { t } = useTranslation();
  const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);
  const { symbols } = useSelector(state => state.watchlist)
  const { UserCompleteDetails } = useSelector(state => state.user);

  const getDigitsBySymbolId = (symbolId) => {
    return symbols?.[symbolId]?.digits;
  };
  const formatDateTime = (serverDateTime) => {    
    if (!serverDateTime) return "--";

    const serverTime = moment.parseZone(serverDateTime);
    const serverOffsetMin = offsetToMinutes(UserCompleteDetails?.serverGMTOffset || "00:00:00");
    const clientOffsetMin = offsetToMinutes(UserCompleteDetails?.gmtOffset || "00:00:00");
    const diffOffset = clientOffsetMin - serverOffsetMin;

    return serverTime.add(diffOffset, "minutes").format("DD-MM-YYYY HH:mm:ss");
  };

  return [
    { title: t("id"), width: 70, dataIndex: 'ticket', render: defaultRender, },
    { title: t("closeTime"), width: 120, dataIndex: 'dateTime', render: (value) => formatDateTime(value) },
    { title: t("openTime"), width: 120, dataIndex: 'openTime', render: (value) => formatDateTime(value) },
    { title: t('symbol'), width: 120, dataIndex: 'symbolName', render: defaultRender, },
    { title: t("closeAmount"), width: 90, dataIndex: "amount", render: (value) => formatPrice(value, decimalPlaces) },
    { title: t("openAmount"), width: 90, dataIndex: "openPositionAmount", render: (value) => formatPrice(value, decimalPlaces) },
    { title: t('type'), width: 70, dataIndex: 'side', render: (value) => value === 1 ? t("buy") : t("sell")  },
    {
      title: t('openPrice'), width: 100, dataIndex: 'openPrice', render: (value, record) => {
        const digits = getDigitsBySymbolId(record.symbolId);
        return value?.toFixed?.(digits);
      },
    },
    {
      title: t('closePrice'), width: 100, dataIndex: 'closePrice', render: (value, row) => {
        const digits = getDigitsBySymbolId(row.symbolId);
        return value?.toFixed?.(digits);
      }
    },
    { title: t('openCommission'), width: 100, dataIndex: 'positionOpenCommission', render: (value) => value ? value.toFixed(2) : '0.00', },
    { title: t('closeCommission'), width: 100, dataIndex: 'commission', render: (value) => value ? value.toFixed(2) : '0.00', },
    { title: t("interest"), width: 80, dataIndex: "intereset", render: defaultRender },
    { title: t('P/L'), width: 100, dataIndex: 'profitLoss', render: (value) => value ? value.toFixed(2) : '0.00', },
    { title: t('openTicket'), width: 70, dataIndex: 'openTicket', render: defaultRender, },
    { title: t("comment"), width: 100, dataIndex: "comment", render: defaultRender },
  ];
};

export default useHistoryCell;


